module.exports = __webpack_public_path__ + "img/yvonne.dc259288.jpg";